import styled from 'styled-components';

export const Container = styled.section`
  border-radius: 4px;
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 42px;
`;
Container.displayName = 'Container';

export const Color = styled.div`
  background-color: #f00;
  border-radius: 4px;
  height: 3px;
  left: -8px;
  position: relative;
  width: calc(100% + 16px);
`;
Color.displayName = 'Color';

export const Logo = styled.img`
  width: 180px;
`;
Logo.displayName = 'Logo';

export const LogoContainer = styled.div`
  align-content: center;
  background-color: #010103;
  border-bottom-style: solid;
  border-bottom-width: 4px;
  border-color: #d74305;
  border-right-style: solid;
  border-right-width: 4px;
  border-top-style: solid;
  border-top-width: 4px;
  display: flex;
  justify-content: center;
  width: 200px;
`;
LogoContainer.displayName = 'LogoContainer';

export const Points = styled.div`
  min-width: 70px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #d74305;
  color: #fff;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 100px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const QuarterTime = styled.div`
  align-items: center;
  background-color: #d74305;
  color: #fff;
  display: flex;
  font-size: 32px;
  font-weight: bold;
  justify-content: center;
  min-width: 60px;
  text-align: center;
`;
QuarterTime.displayName = 'QuarterTime';

export const Separator = styled.div`
  background: #000;
  height: 52px;
  width: 2px;
`;
Separator.displayName = 'Separator';

export const TeamName = styled.div`
  background-color: #010103;
  border-bottom-style: solid;
  border-bottom-width: 4px;
  border-color: #d74305;
  border-top-style: solid;
  border-top-width: 4px;
  color: #fff;
  min-width: 155px;
  padding: 0 8px;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  background-color: #010103;
  border-bottom-style: solid;
  border-bottom-width: 4px;
  border-color: #d74305;
  border-top-style: solid;
  border-top-width: 4px;
  color: #fff;
  display: flex;
  font-size: 38px;
  justify-content: center;
  min-width: 130px;
  text-align: center;
`;
Timer.displayName = 'Timer';
